import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import LoginModal from '../../auth/components/LoginModal.web';
import i18next from '../../base/i18n/i18next';
import Footer from './Footer.web';
import LandingNavbar from './LandingNavbar';
const FAQPage = () => {
    const { t } = useTranslation();
    const [openIndex, setOpenIndex] = useState(null);
    // Set document direction based on current language
    useEffect(() => {
        const rtlLanguages = ['fa', 'ar', 'he'];
        const currentLang = i18next.language || 'fa';
        const isRtl = rtlLanguages.includes(currentLang);
        document.documentElement.dir = isRtl ? 'rtl' : 'ltr';
        document.documentElement.lang = currentLang;
        const handleLanguageChanged = (lng) => {
            const newIsRtl = rtlLanguages.includes(lng);
            document.documentElement.dir = newIsRtl ? 'rtl' : 'ltr';
            document.documentElement.lang = lng;
        };
        i18next.on('languageChanged', handleLanguageChanged);
        return () => {
            i18next.off('languageChanged', handleLanguageChanged);
        };
    }, []);
    const faqItems = [
        {
            question: t('faq.items.whatIsDidar.question'),
            answer: t('faq.items.whatIsDidar.answer')
        },
        {
            question: t('faq.items.howToJoin.question'),
            answer: t('faq.items.howToJoin.answer')
        },
        {
            question: t('faq.items.isItFree.question'),
            answer: t('faq.items.isItFree.answer')
        },
        {
            question: t('faq.items.maxParticipants.question'),
            answer: t('faq.items.maxParticipants.answer')
        },
        {
            question: t('faq.items.devices.question'),
            answer: t('faq.items.devices.answer')
        },
        {
            question: t('faq.items.security.question'),
            answer: t('faq.items.security.answer')
        },
        {
            question: t('faq.items.screenShare.question'),
            answer: t('faq.items.screenShare.answer')
        }
    ];
    const toggleItem = useCallback((index) => {
        setOpenIndex(prev => prev === index ? null : index);
    }, []);
    return (React.createElement("div", { className: 'static-page faq-page' },
        React.createElement(LandingNavbar, null),
        React.createElement(LoginModal, null),
        React.createElement("main", { className: 'static-page-content' },
            React.createElement("div", { className: 'static-page-container' },
                React.createElement("h1", { className: 'static-page-title' }, t('faq.title')),
                React.createElement("p", { className: 'static-page-subtitle' }, t('faq.subtitle')),
                React.createElement("div", { className: 'faq-list' }, faqItems.map((item, index) => (React.createElement("div", { className: `faq-item ${openIndex === index ? 'open' : ''}`, key: index },
                    React.createElement("button", { className: 'faq-question', onClick: () => toggleItem(index), type: 'button' },
                        React.createElement("span", null, item.question),
                        React.createElement("svg", { className: 'faq-icon', fill: 'none', height: '24', viewBox: '0 0 24 24', width: '24', xmlns: 'http://www.w3.org/2000/svg' },
                            React.createElement("path", { d: 'M6 9L12 15L18 9', stroke: 'currentColor', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2' }))),
                    React.createElement("div", { className: 'faq-answer' },
                        React.createElement("p", null, item.answer)))))))),
        React.createElement(Footer, null)));
};
export default FAQPage;
